import { configureStore } from "@reduxjs/toolkit";
import { bloqcibeApi } from "./slices/apiSlice";
import authSliceReducer from "./slices/authSlice"
import trialReducer from "./slices/trialSlice";
import uploadProgressReducer from "./slices/uploadProgressSlice"
import logger from 'redux-logger'
import userDetailsSlice from "./slices/userDetailsSlice";
import subjectSlice from "./slices/subjectSlice";
import showMessageSlice from "./slices/showMessageSlice";
import notificationSlice from "./slices/notificationSlice";
import application from "./slices/applicationSlice";
import financeSlice from "./slices/financeSlice";
import pfasSlice from "./slices/pfasSlice";
import chatSlice from "./slices/chatSlice";

const store = configureStore({
  reducer: { 
    [bloqcibeApi.reducerPath]: bloqcibeApi.reducer,
    auth:authSliceReducer,
    trial:trialReducer,
    uploadProgress:uploadProgressReducer,
    application: application ,
    userDetails: userDetailsSlice,
    subject: subjectSlice,
    showMessage: showMessageSlice,
    notifications: notificationSlice,
    finance: financeSlice,
    pfas: pfasSlice,
    chats: chatSlice,
  },
  middleware: (getDefaultMiddleware) =>
    // getDefaultMiddleware().concat([logger,bloqcibeApi.middleware]),
    getDefaultMiddleware().concat([bloqcibeApi.middleware]),
});

const { dispatch } = store;

export { store, dispatch };
